module.exports = __webpack_public_path__ + "static/media/brand-logo.99a939ea.jpg";